<template>
    <div>
        <h2 class="td-tt">{{$t("new.title19")}}</h2>
        <el-progress
            class="nqtLearnPercent"
            :text-inside="true"
            :stroke-width="$CONST.MENU.MAX_WIDTH_STROKE_PROGESS"
            :percentage="Math.abs(progess) > $CONST.MENU.MAX_PERCENT ? $CONST.MENU.MAX_PERCENT : Math.abs(progess)"
            :format="formats(Math.abs(progess))">
        </el-progress>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";

    export default {
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        data() {
            return {
                progess: 0
            };
        },
        created() {
            this.init({courseId: this.data.courseId, studentId: this.data.studentId});
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile
            }),
        },
        methods: {
            init: async function (param) {
                // Lấy tiến độ của học viên đối với khóa học
                this.progess =  await this.getCourseProcess(param);
            },

            // Lấy tiến độ của khóa học
            getCourseProcess: function (data) {
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/getCourseProcess", {
                        courseId: data.courseId,
                        studentId: data.studentId,
                    })
                    .then((response) => {
                        resolve(Number(response.data));
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
                });
            },

            // Đổi định dạng số -> text
            formats: function(progess) {
                if (document.getElementsByClassName("el-progress-bar__innerText")[0] != null) {
                    document.getElementsByClassName("el-progress-bar__innerText")[0].innerText = progess + "%";
                }
            },

            // vuex
            ...mapMutations("manageDetail", []),
        }
    };
</script>

<style scoped>
    .nqtLearnPercent {
        margin-bottom: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/detail/progess.vue